// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"21238127","230":"4ba32146","295":"bd9086b1","327":"c0638e33","345":"64f6b143","453":"64aababc","508":"1a1eff19","748":"e485b9a9","765":"15cec525","900":"0ba327e5","920":"ca42a768"}[chunkId] + ".chunk.js";
};